export var isLetter = function (char) {
    return /[a-zA-Z]/.test(char);
};
